import {
  List,
  Datagrid,
  EmailField,
  BooleanField,
  TextField,
  DateField,
  ChipField,
  SearchInput,
  TextInput,
  SelectInput,
  BooleanInput,
  Show,
  SimpleShowLayout,
  TopToolbar,
  CreateButton,
  ExportButton,
  Toolbar,
  SaveButton,
  SimpleForm,
  Create,
  useNotify,
} from 'react-admin'
import { Grid, Paper, Typography } from '@mui/material'

import { inviteUser } from '../dataProvider'

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Invite User" />
    <ExportButton />
  </TopToolbar>
)

const InviteToolbar = () => {
  return (
    <Toolbar>
      <SaveButton label="Invite User" />
    </Toolbar>
  )
}

export const UserInvite = () => {
  const notify = useNotify()
  const onInvite = async (params) => {
    await inviteUser(params)

    notify('User will receive invitation on the email.')
  }

  return (
    <Create>
      <SimpleForm toolbar={<InviteToolbar />} onSubmit={onInvite}>
        <TextInput source="email" type="email" />
        <SelectInput
          source="role"
          choices={[
            { id: 'ADMIN', name: 'Admin' },
            { id: 'USER', name: 'user' },
          ]}
        />
      </SimpleForm>
    </Create>
  )
}

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const UserList = ({ isEdit, isDelete }) => (
  <List
    actions={<ListActions />}
    filters={[
      <SearchInput source="search" alwaysOn />,
      <TextInput source="email" />,
      <TextInput source="displayName" />,
      <SelectInput
        source="role"
        choices={[
          { id: 'ADMIN', name: 'ADMIN' },
          { id: 'USER', name: 'USER' },
        ]}
      />,
      <BooleanInput source="isPremium" />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <EmailField source="email" />
      <BooleanField source="isEmailVerified" />
      <DateField source="lastAuthenticatedAt" />
      <BooleanField source="isMFARequired" />
      <DateField source="verificationEmailSentAt" />
      <ChipField source="role" />
      <TextField source="invitedBy" />
      <BooleanField source="isPremium" />
      <DateField source="premiumUpdateAt" />
      <TextField source="displayName" />
    </Datagrid>
  </List>
)

export const UserShow = () => (
  <Show>
    <SimpleShowLayout>
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Identity & Role
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Display Name
            </Typography>
            <TextField source="displayName" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Email
            </Typography>
            <EmailField source="email" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Role
            </Typography>
            <ChipField source="role" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Premium
            </Typography>
            <BooleanField source="isPremium" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Premium Update At
            </Typography>
            <DateField source="premiumUpdateAt" />
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Security & Authentication
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              MFA Required
            </Typography>
            <BooleanField source="isMFARequired" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Last Authenticated At
            </Typography>
            <DateField source="lastAuthenticatedAt" showTime />
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Verification & Invitation
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Email Verified
            </Typography>
            <BooleanField source="isEmailVerified" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Verification Email Sent At
            </Typography>
            <DateField source="verificationEmailSentAt" showTime />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" color="textSecondary" display="block">
              Invited By
            </Typography>
            <TextField source="invitedBy" />
          </Grid>
        </Grid>
      </Paper>
    </SimpleShowLayout>
  </Show>
)
